// @core/api/endpoints/billing/create_usage_record_batch.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateUsageRecordBatchRequest,
  CreateUsageRecordBatchResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create multiple usage records
 * Creates multiple usage records in a single request for efficient batch processing. Returns counts of accepted and rejected records.
 */
export async function CreateUsageRecordBatch(
  data: CreateUsageRecordBatchRequest,
  options?: RequestOptions
): Promise<CreateUsageRecordBatchResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/usage/batch`;
  const requestOptions = options;
  return client.post<CreateUsageRecordBatchResponse>(requestPath, data, requestOptions);
}
